import React from "react";
import PackageItem from "./PackageItem";

/**
 * props:
 *  - packages: array of package objects
 *  - onRequestDelete(packageId)
 */
export default function PackageList({ packages, onRequestDelete,onViewAllSignals }) {
    return (
        <section id="my-packages" className="px-4 space-y-4">
            {packages.map((p) => (
                <PackageItem key={p._id} pkg={p} onRequestDelete={onRequestDelete} onViewAllSignals={onViewAllSignals} />
            ))}
        </section>
    );
}
